import { useState } from 'react'
import { renderMarkdown } from '../lib/markdown.js'

export default function PlaybookView({ page, onSave, canEdit }) {
  const [editing, setEditing] = useState(false)
  const [text, setText] = useState(page?.body || '')

  const startEdit = () => { setText(page?.body || ''); setEditing(true) }
  const save = () => { onSave(text); setEditing(false) }

  return (
    <>
      <div className="eyebrow" style={{ marginBottom: 12 }}><span className="tag-label" style={{ color: 'var(--color-gold)' }}>Hub</span></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h1 className="font-display" style={{ fontSize: 42, margin: '0 0 4px', lineHeight: 0.95, textTransform: 'uppercase', color: 'var(--color-white)' }}>Playbook</h1>
        <div style={{ flex: 1 }} />
        {canEdit && !editing && <button onClick={startEdit} className="btn" style={{ fontSize: 12, padding: '8px 14px' }}>Edit</button>}
        {editing && (
          <>
            <button onClick={() => setEditing(false)} className="btn" style={{ fontSize: 12, padding: '8px 12px' }}>Cancel</button>
            <button onClick={save} className="btn btn-gold" style={{ fontSize: 12, padding: '8px 12px' }}>Save</button>
          </>
        )}
      </div>
      <p style={{ margin: '0 0 22px', fontSize: 13, color: 'var(--color-muted)' }}>Ways of working — comms, decisions, and how we operate.</p>

      {editing ? (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <textarea value={text} onChange={(e) => setText(e.target.value)} spellCheck
            style={{ minHeight: 460, background: 'var(--color-bg-dark)', border: '1px solid var(--color-divider-dark)', borderRadius: 'var(--radius-sm)', padding: 12, color: 'var(--color-white)', fontFamily: 'var(--font-mono, monospace)', fontSize: 12.5, lineHeight: 1.6, resize: 'vertical' }} />
          <div className="tb-prose" style={{ color: 'var(--text-body)', fontSize: 14, lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: renderMarkdown(text) }} />
        </div>
      ) : (
        <div className="tb-prose" style={{ color: 'var(--text-body)', fontSize: 14, lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: renderMarkdown(page?.body || '_No content yet. Click Edit to add the team playbook._') }} />
      )}
    </>
  )
}
